import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";
import Scaffold from "../../../Components/Scaffold";
import { useGetRolesQuery } from "../../../hooks/AdminManagement/useGetRolesQuery";
import { Link, useNavigate } from "react-router-dom";
import { Table } from "antd";
import Moment from "react-moment";

const ExploreRoles = () => {
  const { data, isPending } = useGetRolesQuery();
  const navigate = useNavigate();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string, record: any) => (
        <Link to={`/admin-management/explore-roles/${record.id}`}>{name}</Link>
      ),
      width: "15%",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (description: string) => <span>{description}</span>,
      width: "25%",
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string) => (
        <Moment interval={0} format="DD-MM-YYYY hh:mm a">
          {createdAt}
        </Moment>
      ),
      width: "20%",
    },
    {
      title: "Updated On",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (updatedAt: string) => (
        <Moment interval={0} format="DD-MM-YYYY hh:mm a">
          {updatedAt}
        </Moment>
      ),
      width: "20%",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      render: (id: string) => (
        <Link to={`/admin-management/explore-roles/${id}`}>Edit</Link>
      ),
      width: "10%",
    },
  ];

  return (
    <DashboardLayout
      title="Admin Management"
      back={false}
      right={
        <Link
          to="/admin-management/create-role"
          className="text-white bg-orange py-[13px] px-[37px] rounded-[10px] text-[14px] flex gap-[10px] items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
          <span>Create Role</span>
        </Link>
      }
    >
      <Header title="Explore Roles" />
      <div className="mx-[20px] mt-[20px]">
        <Scaffold left="Explore Roles">
          <div className="flex flex-col h-full">
            <Table
              dataSource={Array.isArray(data?.data) ? data.data : []}
              columns={columns}
              scroll={{ y: "calc(100vh - 200px)" }}
              rowKey="id"
              loading={isPending}
              onRow={(record: any) => ({
                onClick: () =>
                  navigate(`/admin-management/explore-roles/${record.id}`),
              })}
            />
          </div>
        </Scaffold>
      </div>
    </DashboardLayout>
  );
};

export default ExploreRoles;
